import axios from "axios";

const apiClient = axios.create({
  baseURL: "/api"
});

const tokenFromSession = sessionStorage.getItem("access_token");

if (tokenFromSession) {
  apiClient.defaults.headers["Authorization"] = `Bearer ${tokenFromSession}`;
}

apiClient.interceptors.response.use(undefined, err => {
  if (err.response && err.response.status === 401) {
    sessionStorage.removeItem("access_token");
    delete apiClient.defaults.headers["Authorization"];
  }

  throw err;
});

/**
 *
 * @param {string} username
 * @param {string} password
 *
 * @returns {Promise<object>} accessToken
 */
export async function Authenticate(username, password, otp) {
  try {
    const response = await apiClient.post("/auth/login", { username, password, otp });
    const { data } = response;

    const token = data.token;

    apiClient.defaults.headers["Authorization"] = `Bearer ${token}`;
    sessionStorage.setItem("access_token", token);
    sessionStorage.setItem("role", data.role);

    return data;
  } catch (err) {
    alert("Wrong Username or Password");
  }
}

export async function Logout() {
  await apiClient.get("/auth/logout");

  sessionStorage.removeItem("access_token");
  sessionStorage.removeItem("role");

  window.location.href = "/";
}

export function isLoggedIn() {
  return tokenFromSession !== null;
}

export function getUserRole() {
  return sessionStorage.getItem("role");
}

export async function getAudits() {
  const { data } = await apiClient.get("/logs");
  return data;
}

export async function AddCustomer(customer) {
  const { data } = await apiClient.post("/customer", customer);
  return data;
}

/*export async function DeleteCustomer(customerId) {
  const { data } = await axios.delete("/customer?id=" + customerId);
  return data;
}*/

export async function LoadCustomer() {
  const { data } = await apiClient.get("/customer");
  return data;
}

export async function EditCustomer(customer) {
  const { data } = await apiClient.put("/customer", customer);
  return data;
}

export async function TempTokenId() {
  const { data } = await apiClient.post("/auth/token");

  return data.id;
}

/**
 * @return {Promise<string>}
 */
export async function LastUpdateNotifications() {
  const {
    data: { lastUpdate }
  } = await apiClient.get("/info/notifications");
  const d = new Date(lastUpdate);

  return d.toLocaleString();
}

/**
 * @return {string}
 */
export async function LastUpdateComponents() {
  const {
    data: { lastUpdate }
  } = await apiClient.get("/info/components");
  const d = new Date(lastUpdate);

  return d.toLocaleString();
}

export async function LoadSettings() {
  const { data } = await apiClient.get("/settings");
  return data;
}

export async function SaveSettings(settings) {
  const { data } = await apiClient.post("/settings", settings);

  return data;
}

export async function LoadUsers() {
  const { data } = await apiClient.get("/users");

  return data;
}

export async function AddUser(user) {
  const { data } = await apiClient.post("/users", user);
  return data;
}

export async function DeleteUser(user) {
  const { data } = await axios.delete("/users", { data: { id: user.id } });

  return data;
}

export async function LoadQR() {
  const { data } = await apiClient.get("/account/otp");

  return data;
}

export async function LoadAccount() {
  const { data } = await apiClient.get("/account");

  return data;
}

export async function EnableOtp(token) {
  const { data } = await apiClient.post("/account/enable-otp", { token: token });

  return data;
}

export async function DisableOtp() {
  const { data } = await apiClient.post("/account/disable-otp", {});

  return data;
}

export async function ChangePassword(edit) {
  const { data } = await apiClient.post("/account/password", edit);
  return data;
}
